var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.limit || (_vm.element.limit && _vm.step.answers.length > _vm.element.limit))?_c('div',{staticClass:"speech-bubble onboardingbutton",class:_vm.getClass(_vm.element),staticStyle:{"position":"relative"},attrs:{"id":'button' + _vm.getId()},domProps:{"innerHTML":_vm._s(_vm.element.text)},on:{"click":_vm.clicked}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2f75cc6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/onboarding/onboarding-button.vue
// module id = 1939
// module chunks = 0